import React, { useState, useEffect, useContext } from 'react';
import {
  AppBar,
  Box,
  Grid,
  Paper,
  Toolbar,
  makeStyles,
  Typography,
  TextField,
  Button,
  IconButton,
  FormControl,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Radio,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom';
import routes from '../../../Utils/routes.json';
import '../styles.scss';
//Components
import KenCard from '../../../global_components/KenCard';
import KenGrid from '../../../global_components/KenGrid';
import KenDialogBox from '../../../global_components/KenDialogBox';
import KenSelect from '../../../global_components/KenSelect';
import KenCheckbox from '../../../global_components/KenCheckbox/index';
import KenButton from '../../../global_components/KenButton';
import KenInputField from '../../../global_components/KenInputField';
import KenDialog from '../../../global_components/KenDialogBox';
import KenLoader from '../../../Components/KenLoader/index';
// import KenSnackBar from '../../../Components/KenSnackbar';
import KenSnackBar from '../../../global_components/KenSnackbar';
import { debounce } from 'lodash';
// JSON
import {
  getDataForTermEnrolment,
  getCourseOfferingByCourseAndTerm,
  getStudentAndCourseForEnrolment,
  getDataForCourseEnrolment,
  postEnrolmentTillCourses,
} from '../../../Utils/apiServices';
// ICO
import { BsSearch } from 'react-icons/bs';
import {
  AiOutlineMinusSquare,
  AiOutlinePlusSquare,
  AiOutlineFilter,
} from 'react-icons/ai';
const useStyles = makeStyles((theme) => ({
  header: {
    background: '#fff',
    marginTop: '15px',
  },
  title: {
    color: '##272727 ',
    fontWeight: 600,
  },
  selectTabs: {
    padding: '10px',
  },
  studentInfoSection: {
    background: '#fff',
    marginTop: '15px',
    padding: '10px',
  },
  accordionMain: {
    background: 'transparent',
  },
  accordionTable: {
    background: '#fff',
  },
  refreshBtn: {
    float: 'right',
    marginTop: '6px',
    height: '34px !important',
    marginBottom: '8px',
    fontSize: '12px',
    background: '##272727 !important',
    color: '#fff',
    borderRadius: '5px',
  },
  searchFilter: {
    position: 'absolute',
    right: '0px',
    width: '320px',
    justifyContent: 'end',
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'none',
    height: '28px',
    width: '78px',
    marginLeft: '6px',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  sidePannel: {
    position: 'relative',
  },
  sidePannelItem: {
    position: 'relative',
  },
}));
export default function StudentEnrollment(props) {
  const classes = useStyles();
  const userDetails = localStorage.getItem('userDetails');
  const [selectDepartmentOption, setDepartmentOption] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [selectProgramOption, setProgramOption] = useState([]);
  const [selectSpecializationOption, setSpecializationOption] = useState([]);
  const [selectProgramPlanOption, setProgramPlanOption] = useState([]);
  const [selectTermOption, setTermOption] = useState([]);
  const [selectSectionOption, setSectionOption] = useState([]);
  const [studentInfo, setStudentInfo] = useState({
    department: '',
    program: '',
    specialization: '',
    programPlan: '',
    term: '',
    section: '',
  });
  const [accordionCheck, setAccordionCheck] = useState(true);
  const [accordionMandateCheck, setAccordionMandateCheck] = useState(true);
  const [accordionElectiveCheck, setAccordionElectiveCheck] = useState(true);
  const [searchInput, setSearchInput] = React.useState('');
  const [data, setData] = useState([]);
  const [studentData, setStudentData] = useState([]);
  const [electiveData, setElectiveData] = useState([]);
  const [mandatoryData, setMandatoryData] = useState([]);
  const [showData, setShowData] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [courseEnroll, setCourseEnroll] = useState('');
  const [studentID, setStudentID] = useState([]);
  const [courseID, setCourseID] = useState([]);
  const [sectionDialog, setSectionDialog] = useState(false);
  const [enrollDialog, setEnrollDialog] = useState(false);
  const [studentEnrolled, setStudentEnrolled] = useState(false);
  const [sectionFixed, setSectionFixed] = useState();
  const [sectionData, setSectionData] = React.useState([]);
  const [selectedEnrollment, setSelectedEnrollment] = React.useState([]);
  const [trigger, setTrigger] = useState(false);
  const [selectedEnrollement, setSelectedEnrollement] =
    React.useState('Term Enrollment');
  const selectEnrollmentType = [
    { label: 'Term Enrollment', value: 'Term Enrollment' },
    { label: 'Course Enrollment', value: 'Course Enrollment' },
  ];

  //   SnackBar
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const [snackbarMessage, setSnackbarMessage] = React.useState('');

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };

  const handleSnackbarOpen = (severity, message) => {
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };

  //search funcnality//
  const searchTable = (event) => {
    if (event != null) {
      const searchString = event?.target?.value;
      setSearchInput(searchString);
      debouncedSearch();
    }
  };
  const handleSubmitFilters = () => {
    setTrigger(!trigger);
    console.log(trigger);
  };
  const debouncedSearch = debounce(handleSubmitFilters, 700);

  const column = [
    {
      Header: '',
      accessor: 'checked',
      Cell: ({ value, row }) => {
        return (
          <KenCheckbox
            name={`checkbox`}
            className={classes.checkbox}
            value={value}
            onChange={(event) => selectedCheckBoxItem(event, row, studentData)}
            color="primary"
          />
        );
      },
      disableGlobalFilter: true,
    },
    {
      Header: 'Contact Name',
      accessor: 'Contact Name',
      disableGlobalFilter: false,
    },
    {
      Header: 'Registeration Number',
      accessor: 'Registeration Number',
      disableGlobalFilter: false,
    },
  ];
  const column2 = [
    {
      Header: '',
      accessor: 'checked',
      Cell: ({ value, row }) => {
        return (
          <KenCheckbox
            name={`checkbox`}
            className={classes.checkbox}
            value={value}
            onChange={(event) =>
              selectedCheckBoxItem2(event, row, electiveData)
            }
            color="primary"
          />
        );
      },
      disableGlobalFilter: true,
    },
    {
      Header: 'Subject Name',
      accessor: 'Subject Name',
      disableGlobalFilter: false,
    },
    {
      Header: 'Subject Code',
      accessor: 'Subject Code',
      disableGlobalFilter: false,
    },
    {
      Header: 'Term Name',
      accessor: 'Term Name',
      disableGlobalFilter: false,
    },
  ];
  const column3 = [
    {
      Header: '',
      accessor: 'checked',
      Cell: ({ value, row }) => {
        return (
          <KenCheckbox
            name={`checkbox`}
            className={classes.checkbox}
            value={value}
            onChange={(event) =>
              selectedCheckBoxItem2(event, row, electiveData)
            }
            color="primary"
          />
        );
      },
      disableGlobalFilter: true,
    },
    {
      Header: 'Subject Name',
      accessor: 'Subject Name',
      disableGlobalFilter: false,
    },
    {
      Header: 'Subject Code',
      accessor: 'Subject Code',
      disableGlobalFilter: false,
    },
    {
      Header: 'Term Name',
      accessor: 'Term Name',
      disableGlobalFilter: false,
    },
    {
      Header: 'View',
      // accessor: '',
      Cell: ({ value, row }) => {
        return (
          <KenButton
            label="View"
            onClick={() => viewSectionData(value, row, electiveData)}
            variant="primary"
            className={classes.refreshBtn}
          />
        );
      },
      disableGlobalFilter: false,
    },
  ];
  const column4 = [
    {
      Header: '',
      accessor: 'checked',
      Cell: ({ value, row }) => {
        return (
          <KenCheckbox
            name={`checkbox`}
            className={classes.checkbox}
            value={value}
            onChange={(event) =>
              selectedCheckBoxItem3(event, row, mandatoryData)
            }
            color="primary"
          />
        );
      },
      disableGlobalFilter: true,
    },
    {
      Header: 'Subject Name',
      accessor: 'Subject Name',
      disableGlobalFilter: false,
    },
    {
      Header: 'Subject Code',
      accessor: 'Subject Code',
      disableGlobalFilter: false,
    },
    {
      Header: 'Term Name',
      accessor: 'Term Name',
      disableGlobalFilter: false,
    },
  ];
  const column5 = [
    {
      Header: '',
      accessor: 'checked',
      Cell: ({ value, row }) => {
        return (
          <KenCheckbox
            name={`checkbox`}
            className={classes.checkbox}
            value={value}
            onChange={(event) =>
              selectedCheckBoxItem3(event, row, mandatoryData)
            }
            color="primary"
          />
        );
      },
      disableGlobalFilter: true,
    },
    {
      Header: 'Subject Name',
      accessor: 'Subject Name',
      disableGlobalFilter: false,
    },
    {
      Header: 'Subject Code',
      accessor: 'Subject Code',
      disableGlobalFilter: false,
    },
    {
      Header: 'Term Name',
      accessor: 'Term Name',
      disableGlobalFilter: false,
    },
    {
      Header: 'View',
      // accessor: '',
      Cell: ({ value, row }) => {
        return (
          <KenButton
            label="View"
            onClick={() => viewSectionData(value, row, mandatoryData)}
            variant="primary"
            className={classes.refreshBtn}
          />
        );
      },
      disableGlobalFilter: false,
    },
  ];
  const sectionCol = [
    {
      Header: '',
      accessor: 'checked',
      Cell: ({ value, row }) => {
        return (
          <KenCheckbox
            name={`checkbox`}
            className={classes.checkbox}
            value={value}
            onChange={(event) =>
              selectCourseOfferingCheck(event, row, sectionData)
            }
            color="primary"
          />
        );
      },
      disableGlobalFilter: true,
    },
    {
      Header: 'Section Name',
      accessor: 'sectionName',
      disableGlobalFilter: true,
    },
    {
      Header: 'Course Name',
      accessor: 'courseName',
      disableGlobalFilter: true,
    },
    {
      Header: 'Faculty Name',
      accessor: 'FacultyName',
      disableGlobalFilter: true,
    },
  ];

  const handleChangeDepartment = (e) => {
    setStudentInfo({ ...studentInfo, department: e.target.value });
    const ProgramOption = [];
    const dataS = Object.entries(
      filterData.AcdemicProgramsForEachDepartment
    ).filter((item) => {
      if (item[0] == e.target.value) {
        return item;
      }
    });
    if (dataS.length > 0) {
      dataS[0][1].map((items) => {
        ProgramOption.push({
          label: items.AcademicProgramName,
          value: items.AcademicProgramId,
        });
      });
    }
    setProgramOption(ProgramOption);
  };
  const handleChangeProgram = (e) => {
    setStudentInfo({ ...studentInfo, program: e.target.value });
    // For Specialization
    const SpecializationOption = [];
    const dataS = Object.entries(
      filterData.ProgramSpecializationForEachAcedemicProgram
    ).filter((item) => {
      if (item[0] == e.target.value) {
        return item;
      }
    });
    if (dataS.length > 0) {
      dataS[0][1].map((items) => {
        SpecializationOption.push({
          label: items.ProgramSpecializationName,
          value: items.ProgramSpecializationId,
        });
      });
    }
    setSpecializationOption(SpecializationOption);
    // For Program Plan
    const ProgramPlanOption = [];
    const dataS2 = Object.entries(
      filterData.ProgramPlanForEachAcedemicProgram
    ).filter((item) => {
      if (item[0] == e.target.value) {
        return item;
      }
    });
    if (dataS2.length > 0) {
      dataS2[0][1].map((items) => {
        ProgramPlanOption.push({
          label: items.ProgramPlanName,
          value: items.ProgramPlanId,
        });
      });
    }
    setTermOption([]);
    setProgramPlanOption(ProgramPlanOption);
  };
  const handleChangeSpecialization = (e) => {
    setStudentInfo({ ...studentInfo, specialization: e.target.value });
  };
  const handleChangeProgramPlan = (e) => {
    setTermOption([]);
    setStudentInfo({ ...studentInfo, programPlan: e.target.value });
    const TermOption = [];
    const dataS = Object.entries(filterData.TermForEachProgramPlan).filter(
      (item) => {
        if (item[0] == e.target.value) {
          return item;
        }
      }
    );
    if (dataS.length > 0) {
      dataS[0][1].map((items) => {
        TermOption.push({
          label: items.TermName,
          value: items.TermId,
        });
      });
      setTermOption(TermOption);
    }
  };
  const handleChangeTerm = (e) => {
    setShowData(true);
    setStudentInfo({ ...studentInfo, term: e.target.value });
    const SectionOption = [];
    const dataS = Object.entries(filterData.SectionsForEachTerm).filter(
      (item) => {
        if (item[0] == e.target.value) {
          return item;
        }
      }
    );
    if (dataS.length > 0) {
      dataS[0][1].map((items) => {
        SectionOption.push({
          label: items.SectionName,
          value: items.SectionName,
        });
      });
      console.log('SectionOption', SectionOption);
      setSectionOption(SectionOption);
    }
  };
  const handleChangeSection = (e) => {
    setShowData(true);
    setStudentInfo({ ...studentInfo, section: e.target.value });
  };
  const enrollStudent = () => {
    setLoading(true);
    let payload = {
      CourseOfferingIds: courseID,
      StudentIds: studentID,
      AcademicProgramId: studentInfo.program,
      ProgramSpecializationId: studentInfo.specialization,
      ProgramPlanId: studentInfo.programPlan,
      TermId: studentInfo.term,
    };
    postEnrolmentTillCourses(payload)
      .then((res) => {
        console.log('re', res);
        setLoading(false);
        if (res.success) {
          handleSnackbarOpen(
            'success',
            `${studentID.length} Students are enrolled`
          );
          // alert(res.message);
          setEnrollDialog(false);
          setStudentID([]);
          setStudentEnrolled(!studentEnrolled);
        }
      })
      .catch((err) => {
        setLoading(false);
        handleSnackbarOpen('error', 'Something went wrong');
        // alert('Something went wrong');
      });
  };
  const filterBtn = () => {};
  const handleChangeEnrollmentType = (e) => {
    setSelectedEnrollement(e.target.value);
  };
  React.useEffect(() => {
    setLoading(true);
    const data = JSON.parse(userDetails);
    const instituteId = data?.Id;
    getDataForCourseEnrolment(instituteId).then((res) => {
      const DepartmentOption = [];
      res.DepartmentsList.map((item) => {
        DepartmentOption.push({
          label: item.DepartmentName,
          value: item.DepartmentId,
        });
      });
      setDepartmentOption(DepartmentOption);
      setFilterData(res);
      setLoading(false);
    });
  }, []);
  React.useEffect(() => {
    if (studentInfo?.section != undefined) {
      setLoading(true);
    }
    const data = JSON.parse(userDetails);
    const instituteId = data?.Id;
    let payload2 = {
      academicProgramId: studentInfo?.program,
      instituteId: instituteId,
      sectionName: studentInfo?.section,
      termId: studentInfo?.term,
      specializationId: studentInfo?.specialization,
      searchedName: searchInput,
    };
    if (studentInfo?.program === '' || studentInfo?.program || searchInput) {
      setLoading(true);
      getStudentAndCourseForEnrolment(payload2).then((res) => {
        console.log(res);
        let data = [];
        let data2 = [];
        let data3 = [];
        console.log('loading', loading);
        if (!res.message && res.length > 0) {
          res['contactDetails'].map((item) => {
            data.push({
              checked: false,
              contactId: item.ContactId,
              'Contact Name': item.ContactName,
              'Registeration Number': item.RegistrationNumber,
            });
          });
          if (res['ElectiveCourseDetails'].length > 0) {
            res['ElectiveCourseDetails'].map((item) => {
              data2.push({
                checked: false,
                'Subject Name': item.CourseName,
                'Subject Code': item.CourseCode,
                'Term Name': item.TermName,
                CourseOfferingId: item.CourseOfferingId,
              });
            });
          } else {
            data2.push();
          }
          if (res['MandatoryCourseDetails'].length > 0) {
            res['MandatoryCourseDetails'].map((item) => {
              data3.push({
                checked: false,
                'Subject Name': item.CourseName,
                'Subject Code': item.CourseCode,
                'Term Name': item.TermName,
                CourseOfferingId: item.CourseOfferingId,
              });
            });
          } else {
            data3.push();
          }
        }
        setStudentData(data);
        setElectiveData(data2);
        setMandatoryData(data3);
        setLoading(false);
      });
    }
  }, [trigger, studentInfo, studentEnrolled]);
  const handleCourseEnrollment = (e) => {
    setCourseEnroll(e.target.value);
    if (e.target.value === 'NO') {
      setSectionFixed(false);
    } else {
      setSectionFixed(true);
    }
    studentInfo.section = '';
    setStudentInfo({ ...studentInfo });
  };
  const viewSectionData = (value, row, data) => {
    setLoading(true);
    setSectionDialog(true);
    console.log('value, row, data', value, row, data);
    let payload = {
      TermId: studentInfo.term,
      CourseId: data[row.index].CourseOfferingId,
    };
    getCourseOfferingByCourseAndTerm(payload).then((res) => {
      console.log('res', res);
      setLoading(false);
      const checkedItem = row.original;
      setSelectedEnrollment(checkedItem);
      setSectionData(res);
    });
  };
  const selectCourseOfferingCheck = (event, row, sectionData) => {
    // Single Selection for Section Enrollment
    sectionData.forEach((section) => {
      if (section.id === row.original.id) {
        setCourseID([...courseID, section.courseId]);
        return (section.checked = event.target.checked);
      } else {
        return (section.checked = false);
      }
    });
    setSectionData([...sectionData]);
    // Outer Table Select
    const outerTable = mandatoryData.map((item) => {
      if (item.CourseOfferingId === selectedEnrollment.CourseOfferingId) {
        item.checked = true;
      }
      return item;
    });
    setMandatoryData([...outerTable]);
  };
  console.log('courseID', courseID);
  const selectedCheckBoxItem = (event, row, studentData) => {
    const newData = studentData;
    newData.map((items) => {
      if (items.contactId === row.original.contactId) {
        if (event.target.checked === true) {
          setStudentID([...studentID, items.contactId]);
        } else {
          studentID.splice(items.contactId, 1);
          setStudentID([...studentID]);
        }
        return (items.checked = event.target.checked);
      }
    });
    setStudentData([...newData]);

    console.log('studentID', studentID);
  };

  console.log('studentchecked', studentID.length);
  const selectedCheckBoxItem2 = (event, row, electiveData) => {
    const newData = electiveData;
    newData.map((items) => {
      if (items.CourseOfferingId === row.original.CourseOfferingId) {
        return (items.checked = event.target.checked);
      }
    });
    setElectiveData([...newData]);
  };
  const selectedCheckBoxItem3 = (event, row, mandatoryData) => {
    const newData = mandatoryData;
    newData.map((items) => {
      if (items.CourseOfferingId === row.original.CourseOfferingId) {
        if (event.target.checked === true) {
          setCourseID([...courseID, items.CourseOfferingId]);
        } else {
          const newList =
            courseID.length > 0
              ? courseID.filter((item) => {
                  return item !== items.CourseOfferingId;
                })
              : null;
          setCourseID([...newList]);
        }
        return (items.checked = event.target.checked);
      }
    });
    setMandatoryData([...newData]);
  };
  console.log('courseID', courseID);
  const handleSectionDialog = () => {
    setSectionDialog((prevState) => !prevState);
  };
  const handleEnrollDialog = () => {
    setEnrollDialog((prevState) => !prevState);
  };
  const handleSelectChange2 = () => {
    setStudentInfo({
      department: '',
      program: '',
      specialization: '',
      programPlan: '',
      term: '',
      section: '',
    });
    setTrigger(!trigger);
    setLoading(false);
  };

  return (
    <Grid container xs={12}>
      {loading && <KenLoader />}
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar style={{ minHeight: '45px', justifyContent: 'space-between' }}>
          <Typography className={classes.title}>Student Enrollment</Typography>
          <Grid container xs={4} className={classes.sidePannel}>
            <Grid item xs={8} className={classes.sidePannelItem}>
              <KenSelect
                // label="Enrollment"
                optionalLabel={false}
                options={selectEnrollmentType}
                value={selectedEnrollement}
                defaultSearchValue={selectedEnrollement}
                onChange={(e) => handleChangeEnrollmentType(e)}
                placeholder="Select Enrollment"
                required
              />
            </Grid>
            <Grid item className={classes.sidePannelItem}>
              <Button
                variant="contained"
                color="primary"
                className={classes.addButton}
                onClick={handleSelectChange2}
              >
                Clear All
              </Button>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>

      <Grid container xs={12} className={classes.studentInfoSection}>
        <Grid lg={6} md={6} sm={12} xs={12} className={classes.selectTabs}>
          <KenSelect
            label="Institute Department"
            optionalLabel={false}
            options={selectDepartmentOption}
            value={studentInfo?.department || ''}
            defaultSearchValue={studentInfo?.department || ''}
            onChange={(e) => handleChangeDepartment(e)}
            placeholder="Institute Department"
            required
          />
        </Grid>
        <Grid lg={6} md={6} sm={12} xs={12} className={classes.selectTabs}>
          <KenSelect
            label="Academic Program"
            optionalLabel={false}
            options={selectProgramOption}
            value={studentInfo?.program || ''}
            defaultSearchValue={studentInfo?.program || ''}
            onChange={(e) => handleChangeProgram(e)}
            placeholder="Academic Program"
            required
          />
        </Grid>
        <Grid lg={6} md={6} sm={12} xs={12} className={classes.selectTabs}>
          <KenSelect
            label="Program Specialization"
            optionalLabel={false}
            options={selectSpecializationOption}
            value={studentInfo?.specialization || ''}
            defaultSearchValue={studentInfo?.specialization || ''}
            onChange={(e) => handleChangeSpecialization(e)}
            placeholder="Program Specialization"
            required
          />
        </Grid>
        <Grid lg={6} md={6} sm={12} xs={12} className={classes.selectTabs}>
          <KenSelect
            label="Program Plan"
            optionalLabel={false}
            options={selectProgramPlanOption}
            value={studentInfo?.programPlan || ''}
            defaultSearchValue={studentInfo?.programPlan || ''}
            onChange={(e) => handleChangeProgramPlan(e)}
            placeholder="Program Plan"
            required
          />
        </Grid>
        <Grid lg={6} md={6} sm={12} xs={12} className={classes.selectTabs}>
          <KenSelect
            label="Term"
            optionalLabel={false}
            options={selectTermOption}
            value={studentInfo?.term || ''}
            defaultSearchValue={studentInfo?.term || ''}
            onChange={(e) => handleChangeTerm(e)}
            placeholder="Term"
            required
          />
        </Grid>
        <Grid lg={2} md={3} sm={12} xs={12} className={classes.selectTabs}>
          {selectedEnrollement === 'Course Enrollment' ? (
            <FormControl>
              <FormLabel
                style={{
                  color: '#505F79',
                  fontSize: '12px',
                  lineHeight: '16px',
                }}
              >
                Is section fixed ?
              </FormLabel>
              <RadioGroup
                name="radio-buttons-group"
                value={courseEnroll}
                onChange={(e) => handleCourseEnrollment(e)}
                style={{ display: 'flex', flexDirection: 'row' }}
              >
                <FormControlLabel value="YES" control={<Radio />} label="YES" />
                <FormControlLabel value="NO" control={<Radio />} label="NO" />
              </RadioGroup>
            </FormControl>
          ) : null}
        </Grid>
        {courseEnroll === 'YES' ? (
          <Grid lg={4} md={3} sm={12} xs={12} className={classes.selectTabs}>
            <KenSelect
              label="Section"
              optionalLabel={false}
              options={selectSectionOption}
              value={studentInfo.section}
              defaultSearchValue={studentInfo.section || ''}
              onChange={(e) => handleChangeSection(e)}
              placeholder="Section"
              required
            />
          </Grid>
        ) : null}
      </Grid>
      {showData ? (
        <Grid xs={12}>
          <Accordion
            expanded={accordionCheck}
            style={{ marginTop: '10px', boxShadow: 'none' }}
            className={classes.accordionMain}
          >
            <AccordionSummary expandIcon={accordionCheck}>
              {accordionCheck ? (
                <AiOutlineMinusSquare
                  size={20}
                  style={{ marginTop: '10px' }}
                  onClick={() => setAccordionCheck(!accordionCheck)}
                />
              ) : (
                <AiOutlinePlusSquare
                  size={20}
                  style={{ marginTop: '10px' }}
                  onClick={() => setAccordionCheck(!accordionCheck)}
                />
              )}{' '}
              &nbsp;{' '}
              <Grid item xs={5} style={{ marginTop: '10px' }}>
                <span style={{ color: '#092682', font: 'Open Sans' }}>
                  Student List
                </span>
              </Grid>
              <Grid container className={classes.searchFilter}>
                <Grid>
                  <KenInputField
                    required
                    value={searchInput}
                    icon={<BsSearch />}
                    onChange={(e) => searchTable(e)}
                    // onChange={(e) => setSearchInput(e.target.value)}
                    style={{ width: '250px' }}
                  />
                </Grid>
                <Grid>
                  {/* <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={() => filterBtn()}
                    variant="primary"
                    edge="start"
                    className={classes.refreshBtn}
                    style={{ marginLeft: '10px' }}
                  >
                    <AiOutlineFilter />
                    Filter
                  </IconButton> */}
                </Grid>
              </Grid>
            </AccordionSummary>
            <AccordionDetails className={classes.accordionTable}>
              <div style={{ width: '100%' }}>
                <KenGrid
                  columns={column}
                  data={studentData}
                  pagination={{ disabled: false }}
                  toolbarDisabled={true}
                />
              </div>
            </AccordionDetails>
          </Accordion>
          {selectedEnrollement === 'Course Enrollment' ? (
            <>
              {/* Elective Data */}
              <Accordion
                expanded={accordionElectiveCheck}
                style={{ marginTop: '10px', boxShadow: 'none' }}
                className={classes.accordionMain}
              >
                <AccordionSummary expandIcon={accordionElectiveCheck}>
                  {accordionElectiveCheck ? (
                    <AiOutlineMinusSquare
                      size={20}
                      style={{ marginTop: '10px' }}
                      onClick={() =>
                        setAccordionElectiveCheck(!accordionElectiveCheck)
                      }
                    />
                  ) : (
                    <AiOutlinePlusSquare
                      size={20}
                      style={{ marginTop: '10px' }}
                      onClick={() =>
                        setAccordionElectiveCheck(!accordionElectiveCheck)
                      }
                    />
                  )}{' '}
                  &nbsp;{' '}
                  <Grid item xs={5} style={{ marginTop: '10px' }}>
                    <span style={{ color: '#092682', font: 'Open Sans' }}>
                      Elective
                    </span>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails className={classes.accordionTable}>
                  <div style={{ width: '100%' }}>
                    <KenGrid
                      columns={sectionFixed ? column2 : column3}
                      data={electiveData}
                      pagination={{ disabled: false }}
                      toolbarDisabled={true}
                    />
                  </div>
                </AccordionDetails>
              </Accordion>
              {/* Mandatory Data */}
              <Accordion
                expanded={accordionMandateCheck}
                style={{ marginTop: '10px', boxShadow: 'none' }}
                className={classes.accordionMain}
              >
                <AccordionSummary expandIcon={accordionMandateCheck}>
                  {accordionMandateCheck ? (
                    <AiOutlineMinusSquare
                      size={20}
                      style={{ marginTop: '10px' }}
                      onClick={() =>
                        setAccordionMandateCheck(!accordionMandateCheck)
                      }
                    />
                  ) : (
                    <AiOutlinePlusSquare
                      size={20}
                      style={{ marginTop: '10px' }}
                      onClick={() =>
                        setAccordionMandateCheck(!accordionMandateCheck)
                      }
                    />
                  )}{' '}
                  &nbsp;{' '}
                  <Grid item xs={5} style={{ marginTop: '10px' }}>
                    <span style={{ color: '#092682', font: 'Open Sans' }}>
                      Mandatory
                    </span>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails className={classes.accordionTable}>
                  <div style={{ width: '100%' }}>
                    <KenGrid
                      columns={sectionFixed ? column4 : column5}
                      data={mandatoryData}
                      pagination={{ disabled: false }}
                      toolbarDisabled={true}
                    />
                  </div>
                </AccordionDetails>
              </Accordion>
            </>
          ) : null}
          <KenButton
            label="Enroll"
            disabled={studentID.length > 0 ? false : true}
            onClick={() => handleEnrollDialog()}
            variant="primary"
            className={classes.refreshBtn}
          />
        </Grid>
      ) : null}
      <div className="dialogBox-div">
        <KenDialogBox
          title={
            <Typography variant="h6" className={classes.dialogHeader}>
              Select Section
            </Typography>
          }
          open={sectionDialog}
          handleClose={() => handleSectionDialog()}
          negativeButtonClick={() => handleSectionDialog()}
          positiveButtonText="Submit"
          negativeButtonText="Cancel"
          hidePositiveButton={true}
          maxWidth="lg"
          dividers
        >
          <Grid xs={12}>
            {sectionData.length > 0 ? (
              <KenGrid
                columns={sectionCol}
                data={sectionData}
                pagination={{ disabled: true }}
                toolbarDisabled={true}
                isCollasable={false}
              />
            ) : null}
          </Grid>
        </KenDialogBox>
        <KenDialogBox
          title={
            <Typography variant="h6" className={classes.dialogHeader}>
              Confirmation
            </Typography>
          }
          open={enrollDialog}
          // handleClose={() => handleEnrollDialog()}
          negativeButtonClick={() => handleEnrollDialog()}
          positiveButtonText="Okay"
          negativeButtonText="Cancel"
          positiveButtonClick={() => enrollStudent()}
          maxWidth="lg"
          dividers
        >
          <Typography variant="h6">
            Are you want to enroll {studentID.length} student
          </Typography>
        </KenDialogBox>
        <KenSnackBar
          message={snackbarMessage}
          severity={snackbarSeverity}
          autoHideDuration={4000}
          open={openSnackbar}
          handleSnackbarClose={handleSnackbarClose}
          position="Bottom-Right"
        />
      </div>
    </Grid>
  );
}
